import React, { useCallback, useEffect, useState } from "react";

import { Button, Stack, TextField } from "@mui/material";
import { IApiServiceError } from "store";

interface RenameProps {
  title: string;
  onCancel: () => void;
  onSubmit: (value: string) => void;
  cb?: (value: string) => void;
}

export const Rename: React.FC<RenameProps> = ({ title, onCancel, onSubmit, cb }) => {
  const [value, setValue] = useState<string>(title);
  const [error, setError] = useState<string>("");

  const handleSubmit = useCallback(async () => {
    if (cb) {
      try {
        await cb(value);
        onCancel();
      } catch (error) {
        setError((error as IApiServiceError).errors.title[0] || "Something went wrong");
      }
    } else {
      onSubmit(value);
      onCancel();
    }
  }, [value, cb, onSubmit, onCancel]);

  useEffect(() => {
    if (error) {
      setError("");
    }
  }, [value]);

  return (
    <Stack alignItems="stretch" p="20px 10px" gap="10px">
      <TextField
        InputLabelProps={{ shrink: true }}
        label="Name"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{ input: { padding: "12px 14px" } }}
        error={!!error}
        helperText={error}
      />
      <Stack direction="row" gap="10px">
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={!value} onClick={handleSubmit} variant="contained">
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
